<div class="screen-container">
  <div class="container p-0" *ngIf="_appService && _appService.CoreCommonLiterals !== undefined">
    <div class="map-section">
      <ng-container *ngIf="mapApiReady">
        <google-map
          #googleMap
          height="100%"
          width="100%"
          [center]="{ lat: _latitudeCenter, lng: _longitudeCenter }"
          [zoom]="_zoom"
          [options]="{
            styles: commonMapService.Styles,
            maxZoom: commonMapService.MaxZoom,
            mapTypeId: 'roadmap',
            gestureHandling: 'greedy',
            zoomControl: true,
            mapTypeControl: true,
            mapTypeControlOptions: googleMapOptions.mapTypeControlOptions,
            streetViewControl: true,
            fullscreenControl: true
          }"
          (mapReady)="onMapReady($event)"
          (centerChanged)="onCenterChange($event)"
          (zoomChanged)="onZoomChange($event)"
        >
      </google-map>
    </ng-container>
    </div>
   
    <div  class="pl-0 pl-md-4">
      <app-resizable-panel 
      [minWidth]="250" 
      [maxWidth]="maxPanelWidth" 
      [collapsedWidth]="60"
      [initialWidth]="initialPanelWidth"
      [panelId]="'maps-panel'"
      [background]="'white'"
      [icons]="[{id: 1, tooltip: _appService.CoreCommonLiterals.Filter, class: 'fa-solid fa-filter' }]"
      >
      <div class="mb-3 p-3 h-100">
        <div class="card-block card-body" style="height: 100%; overflow: auto;">
          <h5 class="mb-3">{{_appService.CoreCommonLiterals.Filter}}</h5>
          <div class="search-bar">
            <div class="form-group">
              <i class="fa fa-search"></i>
              <input id="map-inputsearch" type="text" class="form-control" [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" [(ngModel)]="searchText" (input)="search($event)" customFocus>
            </div>
          </div>
          <div class="form-group mb-1">
            <label for="visualizationType">Visualization Type</label>
            <custom-select 
              id="visualizationType"
              name="visualizationType"
              [(ngModel)]="visualizationType" 
              [sourceList]="visualizationTypeList" 
              [bordered]="true" 
              required
              (select)="onVisualizationTypeChange($event)">
            </custom-select>
          </div>
          <div class="form-group mb-1" *ngIf="facilitiesList.length && addOnMapping?.Enabled">
            <label for="facilities">{{_appService.CoreCommonLiterals.Facilities}}</label>
            <ss-multiselect-dropdown
              [texts]="_multiSelectTexts" 
              [name]="facilities"
              id="facilities"
              #facilities{{i}}="ngModel"
              [settings]="_multiSelectSettings" 
              [options]="facilitiesList"
              (onAdded)="applyFilters('facilities')"
              (onRemoved)="applyFilters('facilities')"
              [(ngModel)]="facilitiesIds"
              >
            </ss-multiselect-dropdown>
          </div>
          <div>
            <form autocomplete="off">
              <div class="form-group">
                <form-parameters #formParam [context]="this" [formParameterList]="formParameterList" (formParameterChange)="emitChangeParam($event)" [ngClass]="{'disabled-form': !enableFilter}"></form-parameters>
                <div class="text-right mt-5">
                  <button (click)="applyFilters('apply');" type="submit" id="btn-applyfilters" class="btn btn-primary btn-block mt-3">
                    {{_appService.CoreCommonLiterals?.Apply}}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      </app-resizable-panel>
    </div>
  </div>
</div>

<modal 
  #deviceModal
  [(successMessage)]="_successMessage"
  [(errorMessage)]="_errorMessage" 
  *ngIf="_appService && _appService.CoreCommonLiterals !== undefined"
  modalClass="modal-lg"
>
  <modal-header>{{_appService.CoreCommonLiterals.Details}}</modal-header>
  <modal-content>
    <ul class="nav nav-tabs">
      <li class="nav-item" id="map-tab-{{i}}" *ngFor="let b of _alamrsModalTextAttributes;let i=index;" (click)="activeTab = i">
        <a type="button" class="nav-link" [class.active]="(activeTab === i)">{{b.Description}}</a>
      </li>
    </ul>
    <div *ngFor="let b of _alamrsModalTextAttributes;let i=index;">
      <!-- Tab 0 con tabla mejorada -->
      <div class="table-responsive" *ngIf="activeTab === i && i === 0">
        <table class="table table-condensed table-bordered table-striped">
          <tbody>
            <tr>
              <td class="bg-light" style="font-weight: 600;">No. Contrato</td>
              <td>1234567890000</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">No. Medidor</td>
              <td>9876543210000</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Usuario</td>
              <td>José Luis Pérez</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Domicilio</td>
              <td>C. Los Alpes 2760 int 6</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Última lectura</td>
              <td>24/06/2024</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Válvula</td>
              <td>
                <span class="text-success">
                  <i class="fa fa-check-circle mr-2"></i>Abierto
                </span>
              </td>
            </tr>
            <tr *ngIf="!b.TextAttributes?.length">
              <td class="bg-light" style="font-weight: 600;">Alarmas</td>
              <td>Ninguna</td>
            </tr>
            <tr *ngIf="b.TextAttributes?.length">
              <td class="bg-light" style="font-weight: 600;">Alarmas</td>
              <td>
                <div class="d-flex flex-wrap gap-2">
                  <div *ngFor="let t of b.TextAttributes" class="badge p-2 mr-2 mb-1" style="background-color: #e4e4e4; border: 1px solid #dddd;">
                    <span class="mx-1">{{t.Name}}</span>
                    <span class="mx-1" *ngIf="t.Value"> {{t.Value}}</span>
                    <i *ngIf="t.IconType === 1" class="fa fa-info-circle mr-1" style="color: rgb(84, 170, 245); text-align: right; float: right; font-size: 14px;"></i>
                    <i *ngIf="t.IconType === 2" class="fa fa-exclamation-triangle text-warning mr-1" style="text-align: right; float: right; font-size: 14px;"></i>
                    <i *ngIf="t.IconType === 3" class="fa fa-exclamation-circle mr-1" style="color: rgb(219, 84, 74); text-align: right; float: right; font-size: 14px;"></i>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Tarifa de consumo</td>
              <td>Residencial A</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Sector</td>
              <td>Sector A</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Fecha de instalación</td>
              <td>01/01/2024</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Tipo de instalación</td>
              <td>Cuadro</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Caudal</td>
              <td>DN15</td>
            </tr>
            <tr>
              <td class="bg-light" style="font-weight: 600;">Modelo</td>
              <td>{{b.Description}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal-content>
  <modal-footer>
    <div class="text-center w-100">
      <button class="btn btn-primary px-4" (click)="_deviceModal.close()">
        {{_appService.CoreCommonLiterals.ButtonClose}}
      </button>
    </div>
  </modal-footer>
</modal>